import React from "react";

import Login from "./components/Login2";
import Signup from "./components/Signup";
import Confirm from "./components/Confirm";
import Forgot from "./components/Forgot";
import ConfirmForgot from "./components/ConfirmForgot";
import Success from "./components/Success";
import ConfirmationHelp from "../ConfirmationHelp";

const Auth = ({ config, orgId, defaultTab }) => {
  const [page, setPage] = React.useState("login");
  const [pw, setPw] = React.useState(null);

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const confirm = urlParams.get("confirm");
    if (confirm === "true") {
      setPage("confirm");
    }
  }, []);

  switch (page) {
    case "login":
      return <Login setPage={(p) => setPage(p)} config={config} orgId={orgId} defaultTab={defaultTab}/>;
    case "signup":
      return <Signup setPage={(p) => setPage(p)} setPw={(val) => setPw(val)} config={config}/>;
    case "confirm":
      return <Confirm setPage={(p) => setPage(p)} pw={pw} />;
    case "forgot":
      return <Forgot setPage={(p) => setPage(p)} />;
    case "confirm-forgot":
      return <ConfirmForgot setPage={(p) => setPage(p)} />;
    case "success":
      return <Success setPage={(p) => setPage(p)} />;
    case "troubleshoot":
      return <ConfirmationHelp setPage={(p) => setPage(p)} />;

    default:
      return <Login config={config} orgId={orgId}/>;
  }
};

export default Auth;
